import React, { FC } from 'react';

import { Box } from '@adsk/alloy-react-box';

import { SCROLL_CONTAINER_ID } from '../constants';

export const scrollToTop = () => {
  document.getElementById(SCROLL_CONTAINER_ID)?.scrollTo({
    top: 0,
  });
};
export const ScrollContainer: FC = ({ children }) => {
  return (
    <Box id={SCROLL_CONTAINER_ID} overflowY="auto" height="100%">
      {children}
    </Box>
  );
};
